module.exports = __webpack_public_path__ + "static/media/serverError.8f6b16a6.png";